//import VueAnalytics from 'vue-analytics';
import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';

Vue.config.productionTip = false;

Vue.use(VueTheMask);

//Vue.use(VueAnalytics, {
 // id: 'G-4RZWS5PPBK',
 // router,
//});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
